// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"140":"b1d5aa3f42fce069","961":"4b90e49d51853795"}[chunkId] + ".js";
};